// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"21":"01518010","109":"64edbd58","227":"a3267474","254":"e71a6e06","276":"31ec3992","363":"34638fcc","588":"52b4fdb3"}[chunkId] + ".chunk.css";
};